import React, { FC, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DefaultTheme, withTheme } from 'styled-components';
import GradientTitle from 'components/gradient-title/GradientTitle';
import { Conference } from 'types';
import { getApiService, getStorageService } from 'services';
import { getConferenceApi } from 'services/api.factory';
import { BlockTitleContainer, CommitteeContainer } from '../сommmittee/styled';
import {
    ConferenceContainer,
    DescriptionContent,
    DescriptionText,
    ImageContent,
    ContentContainer,
    Title,
    Description,
    ArrowLink,
} from './styles/styled';
import { Icon } from 'kl-b2c-ui-kit';
import ScrollAndDrag from 'components/scroll-and-drag';
import DOMPurify from 'dompurify';

const ArchivedConferences: FC<{ theme: DefaultTheme; currentId?: string }> = ({ theme, currentId }) => {
    const { t } = useTranslation('pages/home');
    const [conferences, setConferences] = useState<Conference[] | null>(null);
    const storageService = getStorageService();
    const apiService = getApiService(storageService);
    const conferenceApi = getConferenceApi(apiService);
    const draggable = useRef(false);

    useEffect(() => {
        conferenceApi.getArchived().then((response) => setConferences(response.data.filter((r) => r.id !== currentId)));
    }, [currentId]);

    if (!conferences?.length) return null;

    return (
        <CommitteeContainer>
            <BlockTitleContainer>
                <GradientTitle
                    variant="h1"
                    label={t('archived-conferences')}
                    startColor="#BBFF33"
                    finishColor="#53F592"
                    startLabelColor={theme.palette.black}
                    finishLabelColor={theme.palette.white}
                />
            </BlockTitleContainer>
            <ContentContainer>
                <ScrollAndDrag gap={24} setDraggable={(val) => (draggable.current = val)}>
                    {conferences.map((conference) => (
                        <ConferenceContainer
                            onClick={(e) => {
                                if (!draggable.current)
                                    window.open(
                                        `/archive/${encodeURI(conference.name)}`,
                                        '_self',
                                        'rel=noopener noreferrer'
                                    );
                                e.stopPropagation();
                            }}
                            key={`archive-${conference.id}`}
                        >
                            <ImageContent image={conference.additionalImage?.fileLink ?? ''} />
                            <DescriptionContent>
                                <DescriptionText>
                                    <Title>{conference.name}</Title>
                                    <Description
                                        dangerouslySetInnerHTML={{
                                            __html: DOMPurify.sanitize(conference.description),
                                        }}
                                    />
                                </DescriptionText>
                                <ArrowLink>
                                    <Icon name={'ArrowRight'} size={32} color={'teal'} />
                                </ArrowLink>
                            </DescriptionContent>
                        </ConferenceContainer>
                    ))}
                </ScrollAndDrag>
            </ContentContainer>
        </CommitteeContainer>
    );
};

export default withTheme(ArchivedConferences);
